import { render, staticRenderFns } from "./vehicleAccidentAdd.vue?vue&type=template&id=015f296c&scoped=true"
import script from "./vehicleAccidentAdd.vue?vue&type=script&lang=js"
export * from "./vehicleAccidentAdd.vue?vue&type=script&lang=js"
import style0 from "./vehicleAccidentAdd.vue?vue&type=style&index=0&id=015f296c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015f296c",
  null
  
)

export default component.exports